import React, { useEffect } from "react";
import * as echarts from "echarts";

const BarChart = ({ chartData }: any) => {
  useEffect(() => {
    if (!chartData || !chartData.series || !chartData.categories) {
      console.warn("chartData is missing or incorrectly formatted");
      return;
    }

    const chartElement = document.getElementById("bar-chart") as HTMLDivElement;
    if (!chartElement) return;

    const chart = echarts.init(chartElement);

    const series = chartData.series.map((item: any) => ({
      name:
        item.name === "engagement"
          ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
          : item.name.charAt(0).toUpperCase() + item.name.slice(1) + ` Index `,
      type: "bar",
      emphasis: { focus: "series" },
      itemStyle: { color: item.color, barBorderRadius: [5, 5, 0, 0] }, // Correctly assign colors
      data: item.data, // Use correct data mapping
      barWidth: 6,
    }));

    const options = {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      grid: {
        top: 25,
        left: "0%",
        right: "5%",
        bottom: "2%",
        containLabel: true,
      },
      // legend: {
      //   data: series.map((s: any) => s.name),
      //   x: "left",
      // },
      xAxis: [
        {
          type: "category",
          axisTick: { show: false },
          data: chartData.categories,
        },
      ],
      yAxis: [{ type: "value", min: 0, max: 8 }],
      series, // Ensure correct order and structure
    };

    chart.setOption(options);

    return () => {
      chart.dispose();
    };
  }, [chartData]);

  return <div id="bar-chart" style={{ width: "100%", height: "257px" }}></div>;
};

export default BarChart;
